import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Permission, PermissionCreate, PermissionFilter } from '../data/permission';

export function createPermissionService(client: AxiosInstance) {
  return createCrudService<Permission, PermissionCreate, PermissionFilter>(
    client,
    '/authorization/Permission',
    'id',
  );
}

export type PermissionService = CrudService<Permission, PermissionCreate, PermissionFilter>;
